/* ──────────────────────────────────────────
   Pro Ase Sports — assets/theme.js
   Runs on every page.
   Cart element IDs match sections/header.liquid:
     #cartBody, #cartFooter, #cartCount,
     #cartDrawerCount, #cartSubtotal
────────────────────────────────────────── */

// ── 1. Header height → CSS variable ──────────
// function setHeaderHeight() {
//   // Header section id in header.liquid is "siteNav" (the sticky nav).
//   // The full header wrapper (announce bar + nav) is the parent of siteNav.
//   const nav = document.getElementById('siteNav');
//   if (!nav) return;
//   const headerEl = nav.closest('header') || nav.parentElement || nav;
//   const height   = headerEl.offsetHeight || nav.offsetHeight;
//   document.documentElement.style.setProperty('--header-height', height + 'px');
//   const main = document.getElementById('MainContent');
//   if (main) main.style.paddingTop = height + 'px';
// }
// setHeaderHeight();
// window.addEventListener('resize', setHeaderHeight, { passive: true });


// ── 2. Nav elevated on scroll ─────────────────
window.addEventListener('scroll', () => {
  const nav = document.getElementById('siteNav');
  if (nav) nav.classList.toggle('elevated', window.scrollY > 10);
}, { passive: true });


// ── 3. Mobile drawer ──────────────────────────
// NOTE: openMenu / closeMenu are defined and exposed by header.liquid.
// theme.js only re-binds the hamburger click as a safety net —
// the actual logic lives in the header section script.
(function () {
  const menuBtn = document.getElementById('menuBtn');
  if (!menuBtn) return;
  // Only add listener if header.liquid hasn't already handled it.
  // header.liquid exposes window.openMenu — if missing, add fallback.
  if (typeof window.openMenu !== 'function') {
    menuBtn.addEventListener('click', function () {
      const overlay = document.getElementById('menuOverlay');
      const drawer  = document.getElementById('mobileDrawer');
      if (overlay) { overlay.classList.add('is-open'); }
      if (drawer)  { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); }
      document.body.style.overflow = 'hidden';
    });
    window.openMenu = function () { menuBtn.click(); };
  }
})();


// ── 4. Search ─────────────────────────────────
// openSearch / closeSearch defined in header.liquid.
// Bind any [data-open-search] buttons that exist outside the header.
document.querySelectorAll('[data-open-search]').forEach(btn => {
  btn.addEventListener('click', () => {
    if (typeof window.openSearch === 'function') window.openSearch();
  });
});


// ── 5. Cart drawer open/close ─────────────────
// openCart / closeCart exposed by header.liquid.
// Bind any [data-open-cart] elements outside the header.
document.querySelectorAll('[data-open-cart]').forEach(btn => {
  btn.addEventListener('click', () => {
    if (typeof window.openCart === 'function') window.openCart();
  });
});


// ── 6. Cart fetch + render ────────────────────
function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

function renderCart(cart) {
  // ── Guard: ensure cart and cart.items exist ──
  if (!cart || typeof cart !== 'object') return;
  const items = Array.isArray(cart.items) ? cart.items : [];

  // ── DOM refs (matching header.liquid IDs exactly) ──
  const bodyEl     = document.getElementById('cartBody');
  const footerEl   = document.getElementById('cartFooter');
  const subtotalEl = document.getElementById('cartSubtotal');
  const drCountEl  = document.getElementById('cartDrawerCount');

  // ── Update all cart count badges ──
  // header.liquid uses id="cartCount" on the nav badge
  // and class="cart-count" can be used on any badge
  const countBadge = document.getElementById('cartCount');
  if (countBadge) {
    countBadge.textContent = cart.item_count;
    countBadge.setAttribute('aria-hidden', cart.item_count === 0 ? 'true' : 'false');
  }
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });

  // ── Update drawer title count "(N)" ──
  if (drCountEl) {
    drCountEl.textContent = '(' + cart.item_count + ')';
  }

  // ── Empty state ──
  if (cart.item_count === 0) {
    if (bodyEl) {
      bodyEl.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty__icon">
            <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24" style="opacity:.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
          </div>
          <div class="cart-empty__title">Your cart is empty</div>
          <p class="cart-empty__sub">Find the perfect pair for your sport</p>
          <a href="/collections/all" onclick="if(typeof closeCart==='function')closeCart()" class="cart-empty__cta">Shop All Shoes →</a>
        </div>`;
    }
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = '';

  // ── Render items ──
  if (bodyEl) {
    bodyEl.innerHTML = `<div class="cart-items">${items.map((item, index) => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          <img
            src="${item.image ? item.image.replace('_original', '_80x80_crop_center') : ''}"
            alt="${item.product_title}"
            width="74" height="74"
            loading="lazy"
          />
        </div>
        <div class="cart-item__info">
          <div class="cart-item__vendor">${item.product_type || 'Shoes'}</div>
          <a href="${item.url || '#'}" class="cart-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price-row">
            <div class="cart-item__qty">
              <button type="button" class="cart-item__qty-btn" data-qty-minus data-key="${item.key}" aria-label="Decrease quantity">−</button>
              <span type="button" class="cart-item__qty-val" data-qty-val>${item.quantity}</span>
              <button type="button" class="cart-item__qty-btn" data-qty-plus data-key="${item.key}" aria-label="Increase quantity">+</button>
            </div>
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          </div>
        </div>
        <button class="cart-item__remove" data-remove-item="${item.key}" aria-label="Remove ${item.product_title}">
          <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>`).join('')}</div>`;

    // Re-bind qty and remove buttons after render
    bodyEl.querySelectorAll('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key   = btn.dataset.key;
        const valEl = btn.parentElement.querySelector('[data-qty-val]');
        const val   = valEl ? parseInt(valEl.textContent, 10) : 1;
        updateCartItem(key, Math.max(0, val - 1), null);
      });
    });
    bodyEl.querySelectorAll('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key   = btn.dataset.key;
        const valEl = btn.parentElement.querySelector('[data-qty-val]');
        const val   = valEl ? parseInt(valEl.textContent, 10) : 1;
        updateCartItem(key, val + 1, null);
      });
    });
    bodyEl.querySelectorAll('[data-remove-item]').forEach(btn => {
      btn.addEventListener('click', () => updateCartItemByKey(btn.dataset.removeItem, 0));
    });
  }

  // ── Subtotal ──
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  // ── Savings (optional element) ──
  const savingsEl = document.getElementById('cartSavings');
  if (savingsEl) {
    const savings = items.reduce((acc, item) => acc + (item.original_line_price - item.final_line_price), 0);
    savingsEl.textContent = savings > 0 ? `You save ${formatMoney(savings)} on this order!` : '';
    savingsEl.style.display = savings > 0 ? 'block' : 'none';
  }
}

function fetchCart() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(err => console.error('[ProAse] fetchCart error:', err));
}

// Update by line index (1-based)
function updateCartItem(key, qty, line) {
  const payload = line ? { line: line, quantity: qty } : { id: key, quantity: qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(r => {
    if (!r.ok) throw new Error('Cart change failed: ' + r.status);
    return r.json();
  })
  .then(cart => {
    // Guard: /cart/change.js returns the cart object
    if (!cart || typeof cart !== 'object') throw new Error('Invalid cart response');
    renderCart(cart);
    if (typeof showToast === 'function') {
      showToast(qty === 0 ? 'Item removed from cart' : 'Cart updated');
    }
  })
  .catch(err => {
    console.error('[ProAse] updateCartItem error:', err);
    // Fallback: re-fetch fresh cart data
    fetchCart();
  });
}

// Update by item key
function updateCartItemByKey(key, qty) {
  updateCartItem(key, qty, null);
}


// ── 7. Add to cart ────────────────────────────
function addToCart(variantId, qty, productTitle) {
  qty = qty || 1;
  productTitle = productTitle || '';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => {
    if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
    return r.json();
  })
  .then(item => {
    showToast('✓ Added to Cart — ' + (productTitle || item.title));
    fetchCart();
    if (typeof window.openCart === 'function') window.openCart();
  })
  .catch(err => {
    console.error('[ProAse] addToCart error:', err);
    showToast('Error adding to cart. Please try again.');
  });
}


// ── 8. Toast ──────────────────────────────────
function showToast(msg) {
  const t = document.getElementById('paToast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._toastTimer);
  t._toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
}


// ── 9. Wishlist (localStorage) ────────────────
function toggleWishlist(btn, productId, productTitle) {
  const STORAGE_KEY = 'pa_wishlist';
  let list = [];
  try { list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) {}
  const idx = list.indexOf(String(productId));
  if (idx === -1) {
    list.push(String(productId));
    btn.classList.add('liked');
    showToast('♡ Added to Wishlist — ' + productTitle);
  } else {
    list.splice(idx, 1);
    btn.classList.remove('liked');
    showToast('Removed from Wishlist');
  }
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  const path = btn.querySelector('path');
  if (path) path.setAttribute('fill', btn.classList.contains('liked') ? '#da362c' : 'none');
}

// Restore wishlist on load
(function restoreWishlist() {
  let list = [];
  try { list = JSON.parse(localStorage.getItem('pa_wishlist') || '[]'); } catch(e) {}
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const id = btn.getAttribute('data-product-id');
    if (list.includes(String(id))) {
      btn.classList.add('liked');
      const path = btn.querySelector('path');
      if (path) path.setAttribute('fill', '#da362c');
    }
  });
})();


// ── 10. Scroll reveal ─────────────────────────
const revObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revObs.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal, .reveal-l, .reveal-r').forEach(el => revObs.observe(el));


// ── 11. Live search results ───────────────────
(function initLiveSearch() {
  const searchInput = document.getElementById('searchInput');
  if (!searchInput) return;
  let searchTimer;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      const q = searchInput.value.trim();
      if (q.length < 2) {
        const res = document.getElementById('searchResults');
        if (res) { res.classList.remove('has-results'); res.innerHTML = ''; }
        return;
      }
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
        .then(r => r.json())
        .then(data => renderSearchResults(data))
        .catch(() => {});
    }, 300);
  });
})();

function renderSearchResults(data) {
  const res = document.getElementById('searchResults');
  if (!res) return;
  const products = data?.resources?.results?.products || [];
  if (products.length === 0) { res.classList.remove('has-results'); res.innerHTML = ''; return; }
  res.classList.add('has-results');
  res.innerHTML = products.map(p => `
    <a href="${p.url}" class="search-result-item" onclick="if(typeof closeSearch==='function')closeSearch()">
      <div class="search-result-img">
        ${p.featured_image
          ? `<img src="${p.featured_image.url.replace('_original','_100x100')}" alt="${p.title}" width="52" height="52" loading="lazy"/>`
          : ''}
      </div>
      <div>
        <div class="search-result-name">${p.title}</div>
        <div class="search-result-sport">${p.product_type || ''}</div>
      </div>
      <div class="search-result-price">${p.price ? '₹' + (p.price / 100).toLocaleString('en-IN') : ''}</div>
    </a>`).join('');
}


// ── 12. Keyboard accessibility ────────────────
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (typeof window.closeMenu   === 'function') window.closeMenu();
  if (typeof window.closeSearch === 'function') window.closeSearch();
  if (typeof window.closeCart   === 'function') window.closeCart();
});


// ── 13. Reel / video interactions ─────────────
document.querySelectorAll('.reel-card').forEach(card => {
  const vid = card.querySelector('video');
  if (!vid) return;
  card.addEventListener('mouseenter', () => vid.play().catch(() => {}));
  card.addEventListener('mouseleave', () => vid.pause());
});

function toggleReel(id, btn) {
  const v = document.getElementById(id);
  if (!v) return;
  if (v.paused) {
    v.play().catch(() => {});
    btn.innerHTML = '<svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  } else {
    v.pause();
    btn.innerHTML = '<svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  }
}

function toggleMute(vidId, btnId) {
  const v = document.getElementById(vidId);
  const b = document.getElementById(btnId);
  if (!v || !b) return;
  v.muted = !v.muted;
  b.innerHTML = v.muted
    ? '<svg width="10" height="10" fill="currentColor" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2"/><line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2"/></svg>'
    : '<svg width="10" height="10" fill="currentColor" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
}


// ── 14. Newsletter form ───────────────────────
document.querySelectorAll('[data-newsletter-form]').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    if (input && input.value.trim()) {
      showToast('✓ Subscribed! Welcome to Pro Ase Sports.');
      input.value = '';
    }
  });
});


// ── 15. Initial cart count on page load ───────
// Uses fetchCart() which calls renderCart() → updates badge + body
fetchCart();
